import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../ducks/integration';
import * as apiIntegrate from '../services/apiIntegrate';
import * as api from '../services/api';
// import { toast } from 'react-toastify';
import toast from '../components/Toastify';
// import { load, loaded } from 'ducks/loading';
import { browserHistory } from 'react-router';
import { addDataSrc } from '../ducks/widget';

const params = (new URL(window.location)).searchParams;
const name = params.get('u'), intN = params.get('int');
const fbGGLParam = params.get('auth');
const Linkdin = params.get('isMsg'); const SMAuth = params.get('smauth');
if (name == '1') {
  let repURL = window.location.href.replace('&auth=1', '');
  browserHistory.push(repURL);
  //browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'integration?int=' + intN);
  setTimeout(() => {
    toast.error('Integration already added');
  }, 100);
}
else if (name == '0') {
  let repURL = window.location.href.replace('&auth=0', '');
  browserHistory.push(repURL);
  setTimeout(() => {
    toast.success('Integration created successfully');
  }, 100);
}
else if (name == '2') {
  let repURL = window.location.href.replace('&auth=2', '');
  browserHistory.push(repURL);
  setTimeout(() => {
    toast.error('Unauthorized access');
  }, 100);
}
//facebook Integartion
if (fbGGLParam) {
  // let URLFBGGl = window.location.href;
  // let testFBGGlUrl = URLFBGGl.split('&');
  if (fbGGLParam == '0') {
    let repURL = window.location.href.replace('&auth=0', '');
    browserHistory.push(repURL);
    setTimeout(() => {
      toast.success('Integration created successfully');
    }, 1000);
  }
  else if (fbGGLParam == '1') {
    let repURL = window.location.href.replace('&auth=1', '');
    browserHistory.push(repURL);
    setTimeout(() => {
      toast.success('Please try again after some time or contact support team');
    }, 1000);
  }
  else if (fbGGLParam == '2') {
    let repURL = window.location.href.replace('&auth=2', '');
    browserHistory.push(repURL);
    setTimeout(() => {
      toast.success('Integration already added');
    }, 1000);
  }

  // if (testFBGGlUrl.length > 2) {
  //   browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'widget' + window.location.search);
  // }
  // else {
  //   browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'integration?int=' + intN);
  // }
}
//   else if (fbGGLParam == '2') {
//     setTimeout(() => {
//       toast.error('Invalid user access token request');
//     }, 100);
//   }
//   else if (fbGGLParam == '3') {
//     setTimeout(() => {
//       toast.error('Invalid get the request for ' + intN + ' pages');
//     }, 100);
//   }
//   else if (fbGGLParam == '4') {
//     setTimeout(() => {
//       toast.error('Invalid get the request for a user account');
//     }, 100);
//   }
//   else if (fbGGLParam == '5') {
//     setTimeout(() => {
//       toast.error('' + intN + ' Account already in use');
//     }, 100);
//   }
//   else if (fbGGLParam == '6') {
//     setTimeout(() => {
//       toast.error('Invalid ' + intN + ' integration request');
//     }, 100);
//   }
// }

//linkedin
if (Linkdin == '1') {
  let URL = window.location.href;
  let testUrl = URL.split('&');
  if (testUrl.length > 2) {
    browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'widget' + window.location.search);
  }
  else {
    browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'integration?int=' + intN);
  }
  setTimeout(() => {
    toast.error('Linkedin Account already in use');
  }, 100);
}

//surveymonkey
if (SMAuth) {
  let URLFBGGl = window.location.href;
  let testFBGGlUrl = URLFBGGl.split('&');
  if (SMAuth == '0') {
    setTimeout(() => {
      toast.success('Integration created successfully');
    }, 1000);
  }
  else if (SMAuth == '1') {
    setTimeout(() => {
      toast.success('Please try again after some time or contact support team');
    }, 1000);
  }
  if (testFBGGlUrl.length > 2) {
    browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'widget' + window.location.search);
  }
  else {
    browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'integration?int=' + intN);
  }
}



//INTEGRATION MASTER
// function* getUsIntMst(action) {
//   try {
//     //yield put(load());
//     const res = yield call(api.POST, '/master/getUsIntMst', action.data);
//     if (res.status == 'success') {
//       yield put(actions.usIntMstSuccess(res.data));
//     }
//     //yield put(loaded());
//   }
//   catch (e) {
//     toast.error(e.message);
//   }
// }

//IntMstList
function* getIntMstList(action) {
  try {
    // //yield put(load());
    const res = yield call(api.GET, '/master/getIntMstList?sa=' + action.data.sa + '&ty=' + action.data.ty);
    if (res.status == 'success') {
      yield put(actions.getIntMstListSuccess(res.data));
    }
    // //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}


function* updADUsInt(action) {
  try {
    //yield put(load());
    const res = yield call(api.POST, '/master/updADUsInt', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* getFBPostInt() {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/facebookpost/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createFBPage(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/facebookpost/createPage', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteFBList(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/facebookpost/deletePage?_id=' + action.data._id + '&pgid=' + action.data.pgid);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteFB(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/facebookpost/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* getFBReviewInt(action) {
  try {
    if (action.data.isCallInterVal !== true) {
      yield put(actions.intSuccessLoader(true));
    }
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/facebook/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createFBReviewIntIA(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/facebook/createPage', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteFBReviewIntIA(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/facebook/deleteList?_id=' + action.data._id + '&id=' + action.data.id);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteFBReviewInt(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/facebook/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//GMB POST
function* getGGLPostInt() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/googlepost/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createGMBPostIntIA(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/googlepost/createPage', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteGGLPostIntIA(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/googlepost/deletePage', action.data);
    if (res.status == 'success') {
      toast.info(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteGGLPostInt(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/googlepost/delete?_id=' + action.data);
    if (res.status == 'success') {
      toast.info(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Google Review
function* getGGLReviewInt(action) {
  try {
    if (action.data.isCallInterVal !== true) {
      yield put(actions.intSuccessLoader(true));
    }
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/gmb/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createGGLReviewIntIA(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/gmb/createPage', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteGGLReviewIntIA(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/gmb/deletePage', action.data);
    if (res.status == 'success') {
      toast.info(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteGGLReviewInt(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/gmb/delete?_id=' + action.data);
    if (res.status == 'success') {
      toast.info(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* syncLastestPages(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/googlebusiness/syncLastestPages?id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//TWITTER POST
function* getTwitPostInt() {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/twitterpost/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createTwitterUN(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/twitterpost/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteTwitter(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/twitterpost/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Instagram post
function* getInstaPostInt() {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/instapost/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createInstaPostInt(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/instapost/createPage', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteInstaPostInt(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/instapost/deletePage?pgid=' + action.data.pgid + '&_id=' + action.data._id);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteInstaPost(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/instapost/delete?_id=' + action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Google place review
function* getGooglePlace(action) {
  try {
    if (action.data.isCallInterVal !== true) {
      yield put(actions.intSuccessLoader(true));
    }
    ////yield put(load());
    const res = yield call(apiIntegrate.GET, '/google/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
      // yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    ////yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createGooglePlace(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    // let objParamsPlace = action.data;
    // delete objParamsPlace.widgetById;
    const res = yield call(apiIntegrate.POST, '/google/create', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      //check anid exist or not into userintegration
      //is not exist then call add data source api 
      // let objParams = {};//Parameter for add data source
      // if (res.data && res.data.length > 0) {
      //   for (let i = 0; i < res.data.length; i++) {
      //     let element = res.data[i];
      //     if (element.anid.length > 0) {
      //       let filterAnid = element.anid.filter(x => x.nid == action.data._id);
      //       if (filterAnid.length > 0) {
      //         element['defaultChecked'] = true;
      //       } else {
      //         element['defaultChecked'] = false;
      //       }
      //     }
      //   }
      //   let element1 = res.data[0];
      //   if (element1.anid.length == 0) {
      //     objParams = {
      //       uid: element1._id,
      //       _id: action.data._id,
      //       cn: action.data.cn,
      //       pgrtngavg: element1.d.averageRating ? element1.d.averageRating : 0,
      //       pgrtngcnt: element1.d.totalRating ? element1.d.totalRating : 0,
      //       pu: element1.d.place_id ? element1.d.place_id : '',
      //       iin: 'googleplace',
      //       rmk: action.data.rmk ? action.data.rmk : '',
      //       url: '',
      //       dn: element1.d.dn ? element1.d.dn : '',
      //       widgetById: action.data.widgetById,
      //       pid: element1.d.place_id ? element1.d.place_id : ''
      //     };
      //     yield put(addDataSrc(objParams));
      //     element1['defaultChecked'] = true;
      //   }
      // }
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteGooglePlace(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/google/delete?_id=' + action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//capterra review
function* getCapterra(action) {
  try {
    if (action.data.isCallInterVal !== true) {
      yield put(actions.intSuccessLoader(true));
    }
    ////yield put(load());
    const res = yield call(apiIntegrate.GET, '/capterra/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    ////yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createCapterra(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/capterra/createCapterra', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteCapterra(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/capterra/delete?_id=' + action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* syncReviews(action) {
  try {
    ////yield put(load());
    const res = yield call(apiIntegrate.GET, '/capterra/sync?id=' + action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      // yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
      yield put(actions.successLoader(false));
    }
    ////yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//webhook
function* getWebhook(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/webhook/get?inm=' + action.data);
    if (res.status == 'success') {
      yield put(actions.webhookSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createWebhook(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/webhook/create', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.webhookSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteWebhook(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/webhook/delete?_id=' + action.data.id + '&inm=' + action.data.inm);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.webhookSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//twitter
function* twitterOauth(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/twitterpost/ouathCreate?url=' + action.data);
    if (res.status == 'success') {
      window.location.href = res.url;
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteUNorTag(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/twitterpost/deleteUNorTag', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* updateFilter(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/twitterpost/updateFilter', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
      yield put(actions.successLoader(false));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Rss
//get
function* getRSS() {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/rss/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createRSS(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/rss/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteRSS(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/rss/delete?id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Tumblr
//get
function* getTumblr() {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/tumblr/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createTumblr(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/tumblr/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteTumblr(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/tumblr/delete?id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//getWidgetForInt
function* getWidgetForInt() {
  try {
    // //yield put(load());
    const res = yield call(api.GET, '/master/getWidgetForInt');
    if (res.status == 'success') {
      yield put(actions.widgetListSuccess(res.data));
    }
    // //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Booking
//get
function* getBooking() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/booking/get');
    if (res.status == 'success') {
      if (res.data && res.data.length > 0) {
        let chkListen = res.data.filter(x => x.d.isListen == true);
        if (chkListen.length == 0) {
          localStorage.removeItem('WIDGET_DATA_LOADER');
        }
      }
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createBooking(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/booking/create', action.data);
    if (res.status == 'success') {
      localStorage.setItem('WIDGET_DATA_LOADER', true);
      localStorage.setItem('W_LOAD_DATA', true);
      //check anid exist or not into userintegration
      //is not exist then call add data source api 
      let objParams = {};//Parameter for add data source
      if (res.data && res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          let element = res.data[i];
          if (element.anid.length > 0) {
            let filterAnid = element.anid.filter(x => x.nid == action.data._id);
            if (filterAnid.length > 0) {
              element['defaultChecked'] = true;
            } else {
              element['defaultChecked'] = false;
            }
          }
        }
        let element1 = res.data[0];
        if (element1.anid.length == 0) {
          objParams = {
            uid: element1._id,
            _id: action.data._id,
            cn: action.data.cn,
            pgrtngavg: element1.d.pgrtngavg ? element1.d.pgrtngavg : 0,
            pgrtngcnt: element1.d.pgrtngcnt ? element1.d.pgrtngcnt : 0,
            pu: element1.d.orgurl ? element1.d.orgurl : '',
            iin: 'bookingreview',
            rmk: action.data.rmk ? action.data.rmk : '',
            url: '',
            dn: element1.d.dn ? element1.d.dn : '',
            widgetById: action.data.widgetById,
            pid: element1._id ? element1._id : ''
          };
          yield put(addDataSrc(objParams));
          res.data[0]['defaultChecked'] = true;
          res.data[0]['dataSourceID'] = element1._id;
        }
      }
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteBooking(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/booking/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//TripAdvisor
//get
function* getTripAdvisor() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/tripadvisor/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createTripAdvisor(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/tripadvisor/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteTripAdvisor(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/tripadvisor/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Trustpilot
//get
function* getTrustpilot() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/trustpilot/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createTrustpilot(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/trustpilot/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteTrustpilot(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/trustpilot/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Airbnb
//get
function* getAirbnb() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/airbnb/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createAirbnb(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/airbnb/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteAirbnb(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/airbnb/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Yelp
//get
function* getYelp() {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/yelp/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createYelp(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/yelp/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteYelp(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/yelp/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Hotels
//get
function* getHotels() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/hotels/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createHotels(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/hotels/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteHotels(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/hotels/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Etsy
//get
function* getEtsy() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/etsy/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createEtsy(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/etsy/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteEtsy(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/etsy/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Houzz
//get
function* getHouzz() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/houzz/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createHouzz(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/houzz/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteHouzz(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/houzz/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Edmunds
//get
function* getEdmunds() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/edmunds/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createEdmunds(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/edmunds/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteEdmunds(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/edmunds/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}


//DealerRater
//get
function* getDealerRater() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/dealerrater/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createDealerRater(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/dealerrater/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteDealerRater(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/dealerrater/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//OpenTable
//get
function* getOpenTable() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/opentable/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createOpenTable(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/opentable/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteOpenTable(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/opentable/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//eBay
//get
function* geteBay() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/ebay/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createeBay(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/ebay/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteeBay(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/ebay/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//BBB
//get
function* getBBB() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/bbb/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createBBB(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/bbb/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteBBB(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/bbb/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//Amzon
//get
function* getAmzon() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/amazon/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createAmzon(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/amazon/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteAmzon(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/amazon/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//GooglePlay
//get
function* getGooglePlay() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/googleplay/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createGooglePlay(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/googleplay/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteGooglePlay(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/googleplay/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//AppleAPP
//get
function* getAppleAPP() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/appleapp/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createAppleAPP(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/appleapp/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteAppleAPP(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/appleapp/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* getUsrIntegration() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/common/getIntegration');
    if (res.status == 'success') {
      yield put(actions.getUsrIntegrationSuccess(res.data));
    }
    else {
      toast.error('Error in get user integration');
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//getReviews
function* getReviews(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/common/getReviews', action.data);
    if (res.status == 'success') {
      yield put(actions.sucessReviewData(res.data));
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//AppSumo
//get
function* getAppSumo() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/appsumo/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createAppSumo(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/appsumo/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteAppSumo(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/appsumo/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//updateReview
function* updateReview(action) {
  try {
    //yield put(load());
    localStorage.setItem('W_LOAD_DATA', true);
    const res = yield call(apiIntegrate.POST, '/common/updateReview', action.data);
    if (res.status == 'success') {
      yield put(actions.iconSuccess(res.data));
      yield put(actions.updateReviewSuccess(res.data));
      yield put(actions.sucessReviewData(res.reviews));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//getImages
function* getImages(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/common/getImages', action.data);
    if (res.status == 'success') {
      yield put(actions.iconSuccess(res.data));
    }
    else if (res.status == 'duplicate') {
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//deleteImage
function* deleteImage(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/common/deleteImage?id=' + action.data.id + '&wbstlnk=' + action.data.wbstlnk);
    if (res.status == 'success') {
      yield put(actions.iconSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//setIconImageURL
function* setIconImageURL(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/common/setIconImageURL', action.data);
    if (res.status == 'success') {
      yield put(actions.iconSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//deleteReview
function* deleteReview(action) {
  try {
    //yield put(load());
    localStorage.setItem('W_LOAD_DATA', true);
    const res = yield call(apiIntegrate.DELETE, '/common/deleteReview?id=' + action.data.id + '&fuid=' + action.data.fuid);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.deleteReviewSuccess(res.data));
      yield put(actions.updateReviewSuccess(res.data));
    }
    else if (res.status == 'duplicate') {
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    // localStorage.setItem('W_LOAD_DATA', false);
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//addCutomReview
function* addCutomReview(action) {
  try {
    //yield put(load());
    localStorage.setItem('W_LOAD_DATA', true);
    const res = yield call(apiIntegrate.POST, '/common/addCutomReview', action.data);
    if (res.status == 'success') {
      yield put(actions.sucessReviewData(res.data));
      yield put(actions.updateReviewSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    // localStorage.setItem('W_LOAD_DATA', false);
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//removeImage
function* removeImage(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/common/removeImage', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//CustomReview
//get
function* getCustomReview() {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/common/getCustomReview');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createCustomReview(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/common/createCustomReview', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteCustReviewInt(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load()); 
    const res = yield call(apiIntegrate.DELETE, '/common/deleteCustomReview?id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteCustomReview(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/common/deleteCustomReview?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//downloadExcelData
function* downloadExcelData(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/common/downloadExcelData?fuid=' + action.data);
    if (res.status == 'success') {
      window.location.href = res.data;
      yield put(actions.successDownloadExcelData(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//CustomWebhook
//get
function* getCustomWebhook(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/custom/get?id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createCustomWebhook(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/custom/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteCustomWebhook(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/custom/delete?_id=' + action.data._id + '&id=' + action.data.id);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//getCustomWBField
function* getCustomWBField(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/custom/getCustomWBField?_id=' + action.data._id + '&id=' + action.data.id);
    if (res.status == 'success') {
      yield put(actions.successCustomWBField(res.data));
      yield put(actions.intSuccess(res.intData));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* addCustomField(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/custom/addCustomField', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteCustomField(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/custom/deleteCustomField', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* updCustomField(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/custom/updCustomField', action.data);
    if (res.status == 'success') {
      yield put(actions.successCustomWBField(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* getCustomCollectorReview(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/customcollectorreview/get', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createCustomCollectorReview(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/customcollectorreview/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteCustomCollectorReview(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/customcollectorreview/delete?id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}


//Aliexpress
//get
function* getAliexpress() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/aliexpress/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//createAliexpress
function* createAliexpress(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/aliexpress/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//deleteAliexpress
function* deleteAliexpress(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/aliexpress/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//G2
//get
function* getG2() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/g2/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//createG2
function* createG2(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/g2/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//deleteG2
function* deleteG2(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/g2/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//YouTubeVideoGallery
//get
function* getYouTubeVideoGallery() {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/youtubevideogallery/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createYouTubeVideoGallery(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/youtubevideogallery/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteYouTubeVideoGallery(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/youtubevideogallery/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//stamped review
function* getStamped() {
  try {
    // yield put(load());
    const res = yield call(apiIntegrate.GET, '/stamped/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    // yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createStamped(action) {
  try {
    // yield put(load());
    const res = yield call(apiIntegrate.POST, '/stamped/create', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    // yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteStamped(action) {
  try {
    // yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/stamped/delete?id=' + action.data._id);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    // yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//tumbler post
function* createTumblrPostInt(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/tumblr/createPage', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
      yield put(actions.successLoader(false));
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteTumblrPostInt(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/tumblr/deletePage', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    yield put(actions.intSuccessLoader(false));
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* getImportreview() {
  try {
    yield put(actions.intSuccessLoader(true));
    const res = yield call(apiIntegrate.GET, '/importreview/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* createImportReview(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    const res = yield call(apiIntegrate.POSTFILE, '/importreview/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteImportReview(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    const res = yield call(apiIntegrate.DELETE, '/importreview/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* uploadCSV(action) {
  try {
    yield put(actions.intSuccessLoader(true));
    const res = yield call(apiIntegrate.POSTFILE, '/importreview/uploadCSV', action.data);
    if (res.status == 'success') {
      yield put(actions.sucessReviewData(res.data));
      // toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    yield put(actions.intSuccessLoader(false));
  }
  catch (e) {
    toast.error(e.message);
  }
}

//TwitterTestimonial
//get
function* getTwitterTestimonial() {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.GET, '/twittertestimonial/get');
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//create
function* createTwitterTestimonial(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.POST, '/twittertestimonial/create', action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.success(res.m);
    }
    else if (res.status == 'duplicate') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//delete
function* deleteTwitterTestimonial(action) {
  try {
    //yield put(load());
    const res = yield call(apiIntegrate.DELETE, '/twittertestimonial/delete?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.intSuccess(res.data));
      toast.info(res.m);
    }
    else if (res.status == 'fail') {
      toast.warning(res.m);
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

export function* watch() {
  //INTEGRATION MASTER 
  yield takeEvery(actions.GET_ACTIVE_INT, getIntMstList);
  yield takeEvery(actions.ACTIVE_DEACTIVE_USER_INTEGRATION, updADUsInt);

  //FACEBOOK POST
  yield takeEvery(actions.GET_FACEBOOK_POST_INTEGRATION, getFBPostInt);
  yield takeEvery(actions.CREATE_IS_FACEBOOK_POST_PAGE_TRUE, createFBPage);
  yield takeEvery(actions.DELETE_IS_FACEBOOK_POST_PAGE_FALSE, deleteFBList);
  yield takeEvery(actions.DELETE_FACEBOOK_POST_INTEGRATION, deleteFB);

  //FACEBOOK REVIEW
  yield takeEvery(actions.GET_FB_REVIEW_INT, getFBReviewInt);
  yield takeEvery(actions.CREATE_FB_REVIEW_INT_IA, createFBReviewIntIA);
  yield takeEvery(actions.DELETE_FB_REVIEW_INT_IA, deleteFBReviewIntIA);
  yield takeEvery(actions.DELETE_FB_REVIEW_INT, deleteFBReviewInt);

  //GMB POST
  yield takeEvery(actions.GET_GMB_POST_INT, getGGLPostInt);
  yield takeEvery(actions.CREATE_IS_GOOGLE_POST_PAGE_TRUE, createGMBPostIntIA);
  yield takeEvery(actions.DELETE_IS_GOOGLE_POST_PAGE_FALSE, deleteGGLPostIntIA);
  yield takeEvery(actions.DELETE_GMB_POST_INT, deleteGGLPostInt);

  //GMB REVIEW
  yield takeEvery(actions.CREATE_IS_GOOGLE_REVIEW_PAGE_TRUE, createGGLReviewIntIA);
  yield takeEvery(actions.GET_GMB_REVIEW_INT, getGGLReviewInt);
  yield takeEvery(actions.DELETE_IS_GOOGLE_REVIEW_PAGE_FALSE, deleteGGLReviewIntIA);
  yield takeEvery(actions.DELETE_GMB_REVIEW_INT, deleteGGLReviewInt);
  yield takeEvery(actions.SYNC_LASTEST_PAGES, syncLastestPages);

  //TWITTER POST
  yield takeEvery(actions.DELETE_TWIT_POST_INT, deleteTwitter);
  yield takeEvery(actions.CREATE_TWIT_POST_INT, createTwitterUN);
  yield takeEvery(actions.GET_TWIT_POST_INT, getTwitPostInt);

  //Instagram post
  yield takeEvery(actions.GET_INSTA_POST_INT, getInstaPostInt);
  yield takeEvery(actions.CREATE_INSTA_POST_INT, createInstaPostInt);
  yield takeEvery(actions.DELETE_INSTA_POST_INT, deleteInstaPostInt);
  yield takeEvery(actions.DELETE_INSTA_POST, deleteInstaPost);

  //Google place review
  yield takeEvery(actions.GET_GOOGLE_PLACE, getGooglePlace);
  yield takeEvery(actions.CREATE_GOOGLEPLACE, createGooglePlace);
  yield takeEvery(actions.DELETE_GOOGLE_PLACE, deleteGooglePlace);

  //capterra review
  yield takeEvery(actions.GET_CAPTERRA, getCapterra);
  yield takeEvery(actions.CREATE_CAPTERRA, createCapterra);
  yield takeEvery(actions.DELETE_CAPTERRA, deleteCapterra);
  yield takeEvery(actions.SYNC_REVIEWS, syncReviews);

  //webhook
  yield takeEvery(actions.GET_WEBHOOK, getWebhook);
  yield takeEvery(actions.CREATE_WEBHOOK, createWebhook);
  yield takeEvery(actions.DELETE_WEBHOOK, deleteWebhook);

  //twitter
  yield takeEvery(actions.TWITTER_OAUTH, twitterOauth);
  yield takeEvery(actions.DELETE_UN_OR_TAG, deleteUNorTag);
  yield takeEvery(actions.UPDATEFILTER, updateFilter);

  //Rss
  yield takeEvery(actions.GET_RSS, getRSS);
  yield takeEvery(actions.CREATE_RSS, createRSS);
  yield takeEvery(actions.DELETE_RSS, deleteRSS);

  //Tumblr
  yield takeEvery(actions.GET_TUMBLR, getTumblr);
  yield takeEvery(actions.CREATE_TUMBLR, createTumblr);
  yield takeEvery(actions.DELETE_TUMBLR, deleteTumblr);

  //Get Widget for Integration
  yield takeEvery(actions.GET_WIDGET_FOR_INT, getWidgetForInt);

  //Booking
  yield takeEvery(actions.GET_BOOKING, getBooking);
  yield takeEvery(actions.CREATE_BOOKING, createBooking);
  yield takeEvery(actions.DELETE_BOOKING, deleteBooking);

  //TripAdvisor
  yield takeEvery(actions.GET_TRIPADVISOR, getTripAdvisor);
  yield takeEvery(actions.CREATE_TRIPADVISOR, createTripAdvisor);
  yield takeEvery(actions.DELETE_TRIPADVISOR, deleteTripAdvisor);

  //Trustpilot
  yield takeEvery(actions.GET_TRUSTPILOT, getTrustpilot);
  yield takeEvery(actions.CREATE_TRUSTPILOT, createTrustpilot);
  yield takeEvery(actions.DELETE_TRUSTPILOT, deleteTrustpilot);

  //Airbnb
  yield takeEvery(actions.GET_AIRBNB, getAirbnb);
  yield takeEvery(actions.CREATE_AIRBNB, createAirbnb);
  yield takeEvery(actions.DELETE_AIRBNB, deleteAirbnb);

  //Yelp
  yield takeEvery(actions.GET_YELP, getYelp);
  yield takeEvery(actions.CREATE_YELP, createYelp);
  yield takeEvery(actions.DELETE_YELP, deleteYelp);

  //Hotels
  yield takeEvery(actions.GET_HOTELS, getHotels);
  yield takeEvery(actions.CREATE_HOTELS, createHotels);
  yield takeEvery(actions.DELETE_HOTELS, deleteHotels);

  //Etsy
  yield takeEvery(actions.GET_ETSY, getEtsy);
  yield takeEvery(actions.CREATE_ETSY, createEtsy);
  yield takeEvery(actions.DELETE_ETSY, deleteEtsy);

  //Houzz
  yield takeEvery(actions.GET_HOUZZ, getHouzz);
  yield takeEvery(actions.CREATE_HOUZZ, createHouzz);
  yield takeEvery(actions.DELETE_HOUZZ, deleteHouzz);

  //Edmunds
  yield takeEvery(actions.GET_EDMUNDS, getEdmunds);
  yield takeEvery(actions.CREATE_EDMUNDS, createEdmunds);
  yield takeEvery(actions.DELETE_EDMUNDS, deleteEdmunds);

  //DealerRater
  yield takeEvery(actions.GET_DEALERRATER, getDealerRater);
  yield takeEvery(actions.CREATE_DEALERRATER, createDealerRater);
  yield takeEvery(actions.DELETE_DEALERRATER, deleteDealerRater);

  //OpenTable
  yield takeEvery(actions.GET_OPENTABLE, getOpenTable);
  yield takeEvery(actions.CREATE_OPENTABLE, createOpenTable);
  yield takeEvery(actions.DELETE_OPENTABLE, deleteOpenTable);

  //eBay
  yield takeEvery(actions.GET_EBAY, geteBay);
  yield takeEvery(actions.CREATE_EBAY, createeBay);
  yield takeEvery(actions.DELETE_EBAY, deleteeBay);

  //BBB
  yield takeEvery(actions.GET_BBB, getBBB);
  yield takeEvery(actions.CREATE_BBB, createBBB);
  yield takeEvery(actions.DELETE_BBB, deleteBBB);

  //Amzon
  yield takeEvery(actions.GET_AMZON, getAmzon);
  yield takeEvery(actions.CREATE_AMZON, createAmzon);
  yield takeEvery(actions.DELETE_AMZON, deleteAmzon);

  //GooglePlay
  yield takeEvery(actions.GET_GOOGLE_PLAY, getGooglePlay);
  yield takeEvery(actions.CREATE_GOOGLE_PLAY, createGooglePlay);
  yield takeEvery(actions.DELETE_GOOGLE_PLAY, deleteGooglePlay);

  //AppleAPP
  yield takeEvery(actions.GET_APPLE_APP, getAppleAPP);
  yield takeEvery(actions.CREATE_APPLE_APP, createAppleAPP);
  yield takeEvery(actions.DELETE_APPLE_APP, deleteAppleAPP);
  yield takeEvery(actions.GET_USR_INTEGRATION, getUsrIntegration);

  //getReviews
  yield takeEvery(actions.GET_REVIEWS, getReviews);

  //AppSumo
  yield takeEvery(actions.GET_APPSUMO, getAppSumo);
  yield takeEvery(actions.CREATE_APPSUMO, createAppSumo);
  yield takeEvery(actions.DELETE_APPSUMO, deleteAppSumo);

  //updateReview
  yield takeEvery(actions.UPDATE_REVIEW, updateReview);

  //getImages
  yield takeEvery(actions.GET_IMAGES, getImages);

  //deleteImage
  yield takeEvery(actions.DELETE_IMAGE, deleteImage);

  //setIconImageURL
  yield takeEvery(actions.SET_ICON_IMAGE_URL, setIconImageURL);

  //deleteReview
  yield takeEvery(actions.DELETE_REVIEW, deleteReview);

  //removeImage
  yield takeEvery(actions.REMOVE_IMAGE, removeImage);

  //addCutomReview
  yield takeEvery(actions.ADD_CUTOM_REVIEW, addCutomReview);

  //CustomReview
  yield takeEvery(actions.GET_CUSTOM_REVIEW, getCustomReview);
  yield takeEvery(actions.CREATE_CUSTOM_REVIEW, createCustomReview);
  yield takeEvery(actions.DELETE_CUSTOM_REVIEW, deleteCustomReview);

  //downloadExcelData
  yield takeEvery(actions.DOWNLOAD_EXCEL_DATA, downloadExcelData);


  yield takeEvery(actions.DELETE_CUST_REVIEW_INT, deleteCustReviewInt);

  //CustomWebhook
  yield takeEvery(actions.GET_CUSTOM_WEBHOOK, getCustomWebhook);
  yield takeEvery(actions.CREATE_CUSTOM_WEBHOOK, createCustomWebhook);
  yield takeEvery(actions.DELETE_CUSTOM_WEBHOOK, deleteCustomWebhook);
  yield takeEvery(actions.GET_CUSTOM_WB_FIELD, getCustomWBField);
  yield takeEvery(actions.ADD_CUSTOM_FIELD, addCustomField);
  yield takeEvery(actions.DELETE_CUSTOM_FIELD, deleteCustomField);
  yield takeEvery(actions.UPD_CUSTOM_FIELD, updCustomField);
  yield takeEvery(actions.GET_CUSTOM_COLLECTOR_REVIEW, getCustomCollectorReview);
  yield takeEvery(actions.CREATE_CUSTOM_COLLECTOR_REVIEW, createCustomCollectorReview);
  yield takeEvery(actions.DELETE_CUSTOM_COLLECTOR_REVIEW, deleteCustomCollectorReview);

  //Aliexpress
  yield takeEvery(actions.GET_ALIEXPRESS, getAliexpress);
  yield takeEvery(actions.CREATE_ALIEXPRESS, createAliexpress);
  yield takeEvery(actions.DELETE_ALIEXPRESS, deleteAliexpress);

  //G2
  yield takeEvery(actions.GET_G2, getG2);
  yield takeEvery(actions.CREATE_G2, createG2);
  yield takeEvery(actions.DELETE_G2, deleteG2);

  //YouTubeVideoGallery
  yield takeEvery(actions.GET_YOUTUBE_VIDEO_GALLERY, getYouTubeVideoGallery);
  yield takeEvery(actions.CREATE_YOUTUBE_VIDEO_GALLERY, createYouTubeVideoGallery);
  yield takeEvery(actions.DELETE_YOUTUBE_VIDEO_GALLERY, deleteYouTubeVideoGallery);

  //stamped review
  yield takeEvery(actions.GET_STAMPED, getStamped);
  yield takeEvery(actions.CREATE_STAMPED, createStamped);
  yield takeEvery(actions.DELETE_STAMPED, deleteStamped);

  //Tumblr Post
  yield takeEvery(actions.CREATE_TUMBLR_POST_INT, createTumblrPostInt);
  yield takeEvery(actions.DELETE_TUMBLR_POST_INT, deleteTumblrPostInt);

  //import review
  yield takeEvery(actions.GET_IMPORT_REVIEW, getImportreview);
  yield takeEvery(actions.CREATE_IMPORT_REVIEW, createImportReview);
  yield takeEvery(actions.DELETE_IMPORT_REVIEW, deleteImportReview);

  yield takeEvery(actions.UPLOAD_CSV, uploadCSV);

  //TwitterTestimonial
  yield takeEvery(actions.GET_TWITTER_TESTIMONIAL, getTwitterTestimonial);
  yield takeEvery(actions.CREATE_TWITTER_TESTIMONIAL, createTwitterTestimonial);
  yield takeEvery(actions.DELETE_TWITTER_TESTIMONIAL, deleteTwitterTestimonial);
}

export default function* rootSaga() {
  yield [
    fork(watch)
  ];
}


// WEBPACK FOOTER //
// ./src/sagas/integration.js